// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/contratti-infragruppo?societaId=&anno=&fornitore=&mostraDisattivi=',
    requestBody: null,
    response: '{ success: true, data: [{ id, societaId, societaNome, fornitore, nomeServizio, importoMensile, daData, aData, attivo }] }'
  },
  {
    method: 'PUT',
    endpoint: '/api/contratti-infragruppo/:id',
    requestBody: '{ fornitore, nomeServizio, importoMensile, daData, aData }',
    response: '{ success: true, data: { id, ... } }'
  },
  {
    method: 'POST',
    endpoint: '/api/contratti-infragruppo',
    requestBody: '{ societaId, fornitore, nomeServizio, importoMensile, daData, aData }',
    response: '{ success: true, data: { id, ... } }'
  },
  {
    method: 'DELETE',
    endpoint: '/api/contratti-infragruppo/:id',
    requestBody: null,
    response: '{ success: true }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
